import BattleStateLogo from "@/inline-assets/battlestate-logo.svg";
import BungieLogo from "@/inline-assets/bungie-logo.svg";
import EAIcon from "@/inline-assets/ea-logo.svg";
import EpicLogoIcon from "@/inline-assets/epic-logo.svg";
import PockeptairIcon from "@/inline-assets/pocketpair-logo.svg";
import RiotLogoIcon from "@/inline-assets/riot-logo.svg";
import ValveLogoIcon from "@/inline-assets/valve-logo.svg";

// This is intentionally untranslated
export type Publisher = keyof typeof PUBLISHER_INFO_MAP;
export const PUBLISHER_INFO_MAP = {
  riot: {
    Icon: RiotLogoIcon,
    name: "Riot Games",
  },
  epic: {
    Icon: EpicLogoIcon,
    name: "Epic Games",
  },
  valve: {
    Icon: ValveLogoIcon,
    name: "Valve",
    width: 64,
    height: 32,
  },
  pocketpair: {
    Icon: PockeptairIcon,
    name: "Pocketpair",
  },
  ea: {
    Icon: EAIcon,
    name: "EA",
  },
  battleState: {
    Icon: BattleStateLogo,
    name: "Battlestate Games",
    width: 64,
    height: 32,
  },
  bungie: {
    Icon: BungieLogo,
    name: "Bungie",
    width: 64,
    height: 32,
  },
} as const;

export const PUBLISHER_ICONS = [
  RiotLogoIcon,
  EpicLogoIcon,
  EAIcon,
  ValveLogoIcon,
];
